import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const ProjectManagement = (props) => {
  const { height, width, fill, className } = props;
  return (
    <svg
      id="project-management"
      width={width}
      height={height}
      fill={fill}
      stroke="none"
      className={className}
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M21.3333 7.16667H17.1667V6.33331C17.1667 5.41413 16.4192 4.66663 15.5 4.66663H10.5C9.58082 4.66663 8.83332 5.41409 8.83332 6.33331V7.16663H4.66668C3.74746 7.16667 3 7.91413 3 8.83331V11.3333C3 12.2525 3.74746 13 4.66668 13H11.3334V12.5833C11.3334 12.353 11.5197 12.1666 11.75 12.1666H14.25C14.4804 12.1666 14.6667 12.353 14.6667 12.5833V13H21.3334C22.2525 13 23 12.2525 23 11.3333V8.83331C23 7.91413 22.2525 7.16667 21.3333 7.16667ZM15.5 7.16667H10.5V6.33331H15.5V7.16667Z" />
      <path d="M22.7689 13.4495C22.6269 13.3791 22.4572 13.3954 22.3318 13.4906C22.0356 13.7148 21.6905 13.8332 21.3333 13.8332H14.6667V15.0832C14.6667 15.3135 14.4803 15.4999 14.25 15.4999H11.75C11.5197 15.4999 11.3333 15.3135 11.3333 15.0832V13.8332H4.66668C4.30941 13.8332 3.96438 13.7148 3.66813 13.4906C3.54238 13.3946 3.37312 13.3783 3.23109 13.4495C3.08953 13.52 3 13.6644 3 13.8227V19.6666C3 20.5858 3.74746 21.3333 4.66668 21.3333H21.3334C22.2525 21.3333 23 20.5858 23 19.6666V13.8227C23 13.6644 22.9105 13.52 22.7689 13.4495Z" />
    </svg>
  );
};
/* eslint-enable max-len */

ProjectManagement.defaultProps = {
  className: null,
};

ProjectManagement.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default ProjectManagement;
